const RELOAD_KEY = 'stale-asset-reload';
const RELOAD_COOLDOWN_MS = 10000;

export const isStaleAssetError = (value) => {
  const msg = value?.message || String(value || '');
  return (
    msg.includes('Unable to preload CSS') ||
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('error loading dynamically imported module') ||
    msg.includes('Importing a module script failed')
  );
};

// At most one reload per cooldown, so a truly missing file can't loop, but a tab is never blocked forever.
export const reloadOnce = () => {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY));
    if (Date.now() - last < RELOAD_COOLDOWN_MS) return false;
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch {
    return false;
  }
  window.location.reload();
  return true;
};

export const installStaleAssetReload = () => {
  if (typeof window === 'undefined') return;

  window.addEventListener('vite:preloadError', (event) => {
    // Only swallow the error when reloading; otherwise Vite resolves the import as undefined and React crashes on `.default`.
    if (reloadOnce()) event.preventDefault();
  });

  window.addEventListener('error', (event) => {
    if (isStaleAssetError(event.error || event.message)) reloadOnce();
  }, true);

  window.addEventListener('unhandledrejection', (event) => {
    if (isStaleAssetError(event.reason)) reloadOnce();
  });
};
